module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form',
    ],

    config: {
        isFullyVertical: true,
    },
}